import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { RouterModule } from '@angular/router'

import { DetailHeaderAction, DetailHeaderModel } from '../models/detail-page.model'
import { DetailActionBarComponent } from '../detail-action-bar/detail-action-bar.component'

/**
 * Header bar with title, status, subtitle, optional chips, and an
 * action row driven by `<app-detail-action-bar>` (reusable independently
 * for any surface that wants the same button styling).
 */
@Component({
    selector: 'app-detail-header',
    standalone: true,
    imports: [CommonModule, RouterModule, DetailActionBarComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './detail-header.component.html',
    styleUrls: ['./detail-header.component.scss']
})
export class DetailHeaderComponent {
    @Input({ required: true }) model!: DetailHeaderModel
    @Input() testId?: string
    @Output() action = new EventEmitter<DetailHeaderAction>()

    onAction(a: DetailHeaderAction): void {
        if (a.disabled) return
        this.action.emit(a)
    }

    statusBadgeClass(tone: string | undefined): string {
        switch (tone) {
            case 'primary':   return 'badge bg-primary'
            case 'success':   return 'badge bg-success'
            case 'secondary': return 'badge bg-secondary'
            case 'warning':   return 'badge bg-warning text-dark'
            case 'danger':    return 'badge bg-danger'
            case 'info':      return 'badge bg-info text-dark'
            default:          return 'badge bg-light text-dark'
        }
    }
}
